import React from 'react'
import packageJson from '../../package.json'
import { QueryClient } from '@tanstack/react-query'
import { TrackingProvider, Tracking } from '../utils'
import SchNetProgramsComponent from './SchNetProgramsComponent'

const { version: APP_VERSION } = packageJson

const ProgramsApp = ({
  gaId,
  gaDebug,
  mtId,
  mtUrl,
  ...props
}) => {
  const tracker = new Tracking({
    enabled: !!(mtId || gaId),
    gaId,
    mtId,
    mtUrl,
    debug: false
  })

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      }
    }
  })

  navigator.sendBeacon(
    'https://api.apps.austauschkompass.de/programs_component/track',
    JSON.stringify({ version: APP_VERSION, url: document.location.href })
  )

  return (
    <TrackingProvider tracker={tracker}>
      <SchNetProgramsComponent {...props} queryClient={queryClient} />
    </TrackingProvider>
  )
}

const DEFAULT_CONFIG = {
  upsell: true,
  upsellPrechecked: false,
  narrow: false,
  gaId: window.AK_TRACKING_GA_ID,
  mtId: window.AK_TRACKING_MT_ID,
  mtUrl: `https://stats.schueleraustausch.net`,
  programApiUrl: 'https://www.schueleraustausch.net',
  orderApiUrl: 'https://api.orders.austauschkompass.de',
  crmApiUrl: 'https://api.crm.austauschkompass.de',
  referrer: document.location.href,
  filter_countryCode: 'US',
  filter_duration: '',
  filter_startYear: null,
  filter_price: null,
}

const FILTER_KEY_REGEX = /^filter_/

const htmlEnvToProps = ({ el }) => {
  const rawAkConfig = el.dataset.akConfig
  const akConfig = JSON.parse(rawAkConfig)

  const filterConfig = {}

  Object.keys(DEFAULT_CONFIG).forEach((key) => {
    /* NOTE: We override `""`, `null` and `undefined` in
     `akConfig` with our defaults.
     Using `Object.assign({}, DEFAULT_CONFIG, akConfig)`
     instead would not!
   */
    if (!(key in akConfig)) {
      akConfig[key] = DEFAULT_CONFIG[key]
    }
  })

  Object.keys(akConfig).forEach((key) => {
    if (key.match(FILTER_KEY_REGEX)) {
      const nestedKeyName = key.replace(FILTER_KEY_REGEX, '')
      filterConfig[nestedKeyName] = akConfig[key]
      delete akConfig[key]
    }
  })

  Object.assign(akConfig, {
    filter: filterConfig
  })

  return akConfig
}

export {
  SchNetProgramsComponent as default,
  ProgramsApp,
  htmlEnvToProps,
}
